import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { type CarouselCardProps } from '@post-office/browser--growth-starburst/common/carouselBaseCard/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import { PlacementFrontend } from '@post-office/browser--townsquare/townsquare-onboarding-widget';

import { JiraOnboardingCard } from '../../../components/JiraOnboardingCard';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

// This is the Message Frontend. In this Placement we have render.Component which takes a React Component which will render your message in the Placement.
export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<CarouselCardProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<CarouselCardProps>(),
		Component: (props: CarouselCardProps) => <JiraOnboardingCard {...props} />,
	},
});
